import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EventService } from "../Services/event.service";

const EventContext = createContext(null);

export const EventProvider = ({ children }) => {
  const { id } = useParams();

  const [event, setEvent] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      const event = await EventService.fetchEvent(id);
      setEvent(event);
    }
    if (id) {
      fetchEvent(id);
    }
  }, [id]);

  return (
    <EventContext.Provider value={{ event , eventId : id }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEvent = () => useContext(EventContext);
